import React from "react";
import "./InfoBubble.scss";

export interface IInfoBubbleProps {
  text?: string;
}

export const InfoBubble: React.FC<IInfoBubbleProps> = ({ text }) => {
  if (!text) {
    return null;
  }

  return (
    <>
      <span className="hidden lg:block max-w-[426px] info-bubble">{text}</span>
      <span className="block lg:hidden info-bubble info-bubble--top-arrow">
        {text}
      </span>
    </>
  );
};
